export default __webpack_public_path__ + "static/Saxvon-1aaa158a24c245673d2c4fe3db3bf391.ttf";